"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = color;
exports.colorToAlpha = colorToAlpha;
exports.fontWeight = fontWeight;
exports.formatInitials = exports.formatFullName = exports.scoreToBgColor = exports.getSpacing = exports.statusToColor = exports.breakpoint = void 0;

var _hexToRgba = _interopRequireDefault(require("hex-to-rgba"));

var _theme = require("./theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpoint = function breakpoint(size) {
  return function (_ref) {
    var theme = _ref.theme;

    switch (size) {
      case 'maxMobile':
        return "(max-width: ".concat(theme.global.breakpoints.small.value, "px)");

      case 'minTablet':
        return "(min-width: ".concat(theme.global.breakpoints.small.value + 1, "px)");

      case 'maxTablet':
        return "(max-width: ".concat(theme.global.breakpoints.medium.value - 1, "px)");

      case 'minDesktop':
        return "(min-width: ".concat(theme.global.breakpoints.medium.value, "px)");

      default:
        return "(min-width: 0px)";
    }
  };
};

exports.breakpoint = breakpoint;

function color(name) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return "".concat(theme.colors && theme.colors[name] || theme.global.colors[name]);
  };
}

var statusToColor = function statusToColor(status) {
  return _theme.statusColors[status];
};

exports.statusToColor = statusToColor;

function colorToAlpha(name, alpha) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return (0, _hexToRgba.default)(color(name)({
      theme: theme
    }), alpha);
  };
}

function fontWeight(variant) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return "".concat(theme.fontWeight[variant]);
  };
}

var getSpacing = function getSpacing(size) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return "".concat(theme.global.spacing[size]);
  };
}; // score colour lookup


exports.getSpacing = getSpacing;
var okMinimum = 70;
var warningMinimum = 30;

function bgColorFromScore(score) {
  if (score >= okMinimum) return _theme.statusColors.ok;
  if (score >= warningMinimum) return _theme.statusColors.warning;
  return _theme.statusColors.critical;
}

var scoreToBgColor = function scoreToBgColor(score) {
  return bgColorFromScore(score);
};

exports.scoreToBgColor = scoreToBgColor;

var formatFullName = function formatFullName(_ref6) {
  var firstName = _ref6.firstName,
      lastName = _ref6.lastName;
  return "".concat(firstName, " ").concat(lastName);
};

exports.formatFullName = formatFullName;

var formatInitials = function formatInitials(_ref7) {
  var firstName = _ref7.firstName,
      lastName = _ref7.lastName;
  return "".concat(firstName[0]).concat(lastName[0]);
};

exports.formatInitials = formatInitials;